import styled from 'styled-components';
import { WIDE_PAGE_WIDTH } from '../Page';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: ${WIDE_PAGE_WIDTH}px;
  margin: 0 auto;
  padding: calc(var(--top-clear) + 10px) 16px 0;
`;

export const Logo = styled.img`
  display: block;
  height: 44px;
  width: auto;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;

  a {
    color: var(--accent);
    font-weight: 600;
  }
`;
